import React from "react";
import { TerminalSummaryTooltip } from "../../../app/data/map/models";

import "./terminalSummaryTooltip.scss";

interface TerminalSummaryTooltipProps {
  info: TerminalSummaryTooltip,
}

const TerminalSummaryInfo: React.FC<TerminalSummaryTooltipProps> = ({ info }) => (
  <div className="terminal-summary-tooltip">
    {info?.city && <div className="terminal-summary-tooltip__label">
      {`${info?.airportCode} - ${info?.terminalName}`} <span className="terminal-summary-tooltip__item_grey">{info?.terminalNumber}</span>
    </div>}

    {info?.physicalAddress && <div className="terminal-summary-tooltip__item">
      {info?.physicalAddress}
    </div>}

    {info?.city && <div className="terminal-summary-tooltip__item">
      {`${info?.city},${info?.stateProvince} ${info?.zipPostalCode}`}
    </div>}

    {info?.phoneNumber && <div className="terminal-summary-tooltip__item">
      {info?.phoneNumber.formatPhone()}
    </div>}
  </div >
);

export default TerminalSummaryInfo;